import { render, staticRenderFns } from "./DeleteTagDialog.vue?vue&type=template&id=f9d9e9d4&"
import script from "./DeleteTagDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteTagDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports